import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import Pagination from 'react-js-pagination'
import ChangeStatusModal from '../../Containers/Order/ChangeStatusModal'
import Modal from 'react-responsive-modal'

class ChangeStatus extends React.Component {
  constructor (props) {
    super(props)
    this.orderStatus = [
      { value: 'checkout', label: 'CHECKOUT' },
      { value: 'payment-pending', label: 'PENDING' }
    ]
    this.state = {
      selected: '',
      showModal: null,
      filter: {
        q: '',
        page: 1,
        status: 'checkout'
      }
    }
  }

  componentDidMount = () => {
    this._fetchOrder()
  }

  _fetchOrder = (filter, event) => {
    if (event) { event.preventDefault() }
    let data = {
      ...this.state.filter,
      ...filter
    }
    this.props.getOrder(data)
  }

  _select = (data, field) => {
    this.setState({ selected: data })
    this._toggleModal(field)
  }

  _changePage = (page) => {
    let filter = {...this.state.filter, page}
    this.setState({ filter })
    this._fetchOrder({ page })
  }

  _toggleModal = (modalId = null) => {
    this.setState({
      showModal: modalId
    })
  }

  _filterChange = (event, field) => {
    let filter = {...this.state.filter}
    let val = event.target.value
    filter[field] = val
    this.setState({ filter })
  }

  render () {
    const { order } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block mb-3 d-flex justify-content-between'>
            <h3 className='title mr-auto'>
              Change Status
              {
                (order.fetching || order.processing) &&
                <div className='badge badge-info ml-2'>{ order.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
          </div>
          <div className='title-block'>
            <form
              className='form-inline'
              onSubmit={(event) => this._fetchOrder(this.state.filter, event)}
            >
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Search by Order Number</label>
                <input
                  style={{width: '280px'}}
                  type='text'
                  className='form-control'
                  value={this.state.order_number}
                  onChange={(event) => this._filterChange(event, 'q')}
                  minLength='15'
                  maxLength='15'
                />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Status</label>
                <select className='form-control' value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')}>
                  {
                    this.orderStatus.map((item, i) => (
                      <option key={i} value={item.value}>{item.label}</option>
                    ))
                  }
                </select>
              </div>
              <div className='form-group mr-2 mb-2'>
                <button className='btn btn-primary' type='submit'>Apply filter</button>
              </div>
            </form>
          </div>
        </header>
        <section className='section'>
          <div className='card-block'>
            <div className='card'>
              {
                !(order.fetching || order.processing) && order.err &&
                <div className='alert alert-danger'>{order.err}</div>
              }
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Order Number</th>
                    <th className='text-center'>Unique Number</th>
                    <th className='text-center'>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    order.data && (order.data.data && order.data.data.length)
                    ? order.data.data.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td className='text-center'>{ item.order_number || '-' }</td>
                          <td className='text-center'>{ item.unique_number || '-' }</td>
                          <td className='text-center'>
                            <button className='btn btn-primary' onClick={() => this._select(item, 'change-status')}>
                              <i className='fa fa-edit' /> { item.status || '-' }
                            </button>
                          </td>
                        </tr>
                      )
                    })
                    : <tr>
                      <td colSpan='3' className='text-center'>-- No Data --</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className='text-center'>
          {
            (order.data && order.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={order.data.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={order.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
        <Modal className={{ modal: 'modal-large' }} open={this.state.showModal === 'change-status'} onClose={this._toggleModal}>
          <ChangeStatusModal detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  getOrder: (filter) => dispatch(OrderActions.orderRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(ChangeStatus)



// WEBPACK FOOTER //
// ./src/Pages/Order/ChangeStatus.js